import "core-js/modules/es6.promise";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.object.values";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import invariant from 'invariant';
import { CameraType, ImageType } from "./CameraModule.types";
import { requestUserMediaAsync } from "./UserMediaManager";
import { CameraTypeToFacingMode, ImageTypeFormat, MinimumConstraints } from "./constants";
export function getImageSize(videoWidth, videoHeight, scale) {
  var width = videoWidth * scale;
  var ratio = videoWidth / width;
  var height = videoHeight / ratio;
  return {
    width: width,
    height: height
  };
}
export function toDataURL(canvas, imageType, quality) {
  invariant(Object.values(ImageType).includes(imageType), "expo-camera: " + imageType + " is not a valid ImageType. Expected a string from: " + Object.values(ImageType).join(', '));
  var format = ImageTypeFormat[imageType];

  if (imageType === ImageType.jpg) {
    invariant(quality <= 1 && quality >= 0, "expo-camera: " + quality + " is not a valid image quality. Expected a number from 0...1");
    return canvas.toDataURL(format, quality);
  } else {
    return canvas.toDataURL(format);
  }
}
export function hasValidConstraints(preferredCameraType, width, height) {
  return preferredCameraType !== undefined && width !== undefined && height !== undefined;
}

function ensureCaptureOptions(config) {
  var captureOptions = {
    scale: 1,
    imageType: ImageType.png,
    isImageMirror: false
  };

  for (var key in config) {
    if (key in config && config[key] !== undefined && key in captureOptions) {
      captureOptions[key] = config[key];
    }
  }

  return captureOptions;
}

var DEFAULT_QUALITY = 0.92;
export function captureImage(video, pictureOptions) {
  var config = ensureCaptureOptions(pictureOptions);
  var scale = config.scale,
      imageType = config.imageType,
      _config$quality = config.quality,
      quality = _config$quality === void 0 ? DEFAULT_QUALITY : _config$quality,
      isImageMirror = config.isImageMirror;
  var videoWidth = video.videoWidth,
      videoHeight = video.videoHeight;

  var _getImageSize = getImageSize(videoWidth, videoHeight, scale),
      width = _getImageSize.width,
      height = _getImageSize.height;

  var canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  var context = canvas.getContext('2d');
  if (!context) throw new Error('Context is not defined');

  if (isImageMirror) {
    context.setTransform(-1, 0, 0, 1, canvas.width, 0);
  }

  context.drawImage(video, 0, 0, width, height);
  var base64 = toDataURL(canvas, imageType, quality);
  return base64;
}

function getSupportedConstraints() {
  if (navigator.mediaDevices && navigator.mediaDevices.getSupportedConstraints) {
    return navigator.mediaDevices.getSupportedConstraints();
  }

  return null;
}

export function getIdealConstraints(preferredCameraType, width, height) {
  var preferredConstraints = {
    audio: false,
    video: {}
  };

  if (hasValidConstraints(preferredCameraType, width, height)) {
    return MinimumConstraints;
  }

  var supports = getSupportedConstraints();
  if (!supports || !supports.facingMode || !supports.width || !supports.height) return MinimumConstraints;

  if (preferredCameraType && Object.values(CameraType).includes(preferredCameraType)) {
    var facingMode = CameraTypeToFacingMode[preferredCameraType];

    if (isWebKit()) {
      var key = facingMode === 'user' ? 'exact' : 'ideal';
      preferredConstraints.video.facingMode = _defineProperty({}, key, facingMode);
    } else {
      preferredConstraints.video.facingMode = {
        ideal: CameraTypeToFacingMode[preferredCameraType]
      };
    }
  }

  if (isMediaTrackConstraints(preferredConstraints.video)) {
    preferredConstraints.video.width = width;
    preferredConstraints.video.height = height;
  }

  return preferredConstraints;
}

function isMediaTrackConstraints(input) {
  return input && typeof input.video !== 'boolean';
}

export function getStreamDevice(preferredCameraType, preferredWidth, preferredHeight) {
  var constraints, stream;
  return _regeneratorRuntime.async(function getStreamDevice$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          constraints = getIdealConstraints(preferredCameraType, preferredWidth, preferredHeight);
          _context.next = 3;
          return _regeneratorRuntime.awrap(requestUserMediaAsync(constraints));

        case 3:
          stream = _context.sent;
          return _context.abrupt("return", stream);

        case 5:
        case "end":
          return _context.stop();
      }
    }
  }, null, null, null, Promise);
}
export function isWebKit() {
  return /WebKit/.test(navigator.userAgent) && !/Edg/.test(navigator.userAgent);
}